import { TileRoleRoute } from '@/types'
import { faDatabase } from '@fortawesome/free-solid-svg-icons'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'
import { ManagementGrid } from '@/routes/admin/components/ManagementGrid/ManagementGrid'

export const ConstantsRoute: TileRoleRoute = {
  path: 'constants',
  text: 'Costanti DB',
  faIcon: faDatabase,
  element: (
    <div className="content-block dx-card wide-card">
      <ManagementGrid
        endpoint={`${import.meta.env.VITE_QSADMINAPI_HOST}/constants`}
        title="Costanti Database"
        columns={[
          {
            dataField: 'nome',
            caption: 'Nome',
            dataType: 'string',
            allowEditing: true,
          },
          {
            dataField: 'valore',
            caption: 'Valore',
            dataType: 'string',
            allowEditing: true,
          },
        ]}
        expandRelations={[]}
        keyField={'nome'}
        storageKey={`constants-state-management-grid`}
        defaultPageSize={20}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      />
    </div>
  ),
  handle: {
    crumb: () => ({
      label: 'Costanti',
      icon: faDatabase,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
